export enum CrosselingScope {
    PER_ATHLETE = 'PER_ATHLETE',
    PER_TEAM = 'PER_TEAM'
}

export interface CrosselingItem{
    id:string;
    name:string;
    description:string;
    amount:number;
    isIncluded?:boolean;
    urlImage:string;
    scope?:CrosselingScope;
    maxStock?:number;
}
